import { useCallback } from 'react';

import { reportInsightIssue } from '../../../services/insights.js';
import { useReportItemIssue } from './useReportItemIssue.js';

const INSIGHT_REPORT_TOASTS = Object.freeze({
  successTitle: 'intelligence.insights.detail.toast.reportedTitle',
  successMessage: 'intelligence.insights.detail.toast.reportedMessage',
  errorTitle: 'intelligence.insights.detail.toast.reportErrorTitle',
  errorMessage: 'intelligence.insights.detail.toast.reportErrorMessage',
});

/**
 * "Report an issue" on an insight (CT-5716). The rules — one request per double
 * click, toasts, final after a success — are `useReportItemIssue`'s; then
 * `onReported` re-reads the insight and `onChanged` tells the page it changed
 * (How to approach reads from it, CT-5714).
 */
export function useReportInsightIssue({ entityType, entityId, insightId, onReported, onChanged } = {}) {
  // The service is read at call time, not captured, so a test can spy on it.
  const send = useCallback(
    () => reportInsightIssue({ entityType, entityId, insightId }),
    [entityType, entityId, insightId],
  );
  return useReportItemIssue({ send, toastKeys: INSIGHT_REPORT_TOASTS, onReported, onChanged });
}

export default useReportInsightIssue;
